/*
 * @Description: 下载任务管理工具，用于处理团队切换时的下载任务暂停
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2025-10-24 20:14:08
 */
import desktopLib from './desktopLib'

/**
 * 暂停当前团队的所有正在下载的任务
 * @param currentGroupId 当前团队ID
 * @returns Promise<{success: boolean, pausedTasks: number}>
 */
export const pauseAllDownloadingTasks = async (
  currentGroupId: string
): Promise<{
  success: boolean
  pausedTasks: number
}> => {
  try {
    // 检查是否在桌面客户端环境
    if (!desktopLib.isDesktop) {
      return {
        success: true,
        pausedTasks: 0
      }
    }

    // 获取当前团队的所有下载任务
    const result = await desktopLib.downloadGetTasks(currentGroupId)

    if (!result.success || !result.data) {
      return {
        success: true,
        pausedTasks: 0
      }
    }

    // 筛选出正在下载的任务
    const downloadingTasks = result.data.filter(
      (task: any) => task.status === 'downloading'
    )

    if (downloadingTasks.length === 0) {
      return {
        success: true,
        pausedTasks: 0
      }
    }

    // 暂停所有正在下载的任务
    const pausePromises = downloadingTasks.map((task: any) =>
      desktopLib.downloadPauseTask(task.id)
    )

    const pauseResults = await Promise.allSettled(pausePromises)

    // 统计成功暂停的任务数量
    const successCount = pauseResults.filter(
      (result) => result.status === 'fulfilled' && result.value.success
    ).length

    return {
      success: true,
      pausedTasks: successCount
    }
  } catch (error) {
    console.error('[DownloadTaskManager] 暂停下载任务时发生错误:', error)
    return {
      success: false,
      pausedTasks: 0
    }
  }
}

/**
 * 检查是否有正在下载的任务
 * @param groupId 团队ID
 * @returns Promise<boolean>
 */
export const hasDownloadingTasks = async (
  groupId: string
): Promise<boolean> => {
  try {
    if (!desktopLib.isDesktop) {
      return false
    }

    const result = await desktopLib.downloadGetTasks(groupId)

    if (!result.success || !result.data) {
      return false
    }

    return result.data.some((task: any) => task.status === 'downloading')
  } catch (error) {
    console.error('[DownloadTaskManager] 检查下载任务状态时发生错误:', error)
    return false
  }
}
